import script from "./compGroupDetailProfiles.vue?vue&type=script&setup=true&lang=js"
export * from "./compGroupDetailProfiles.vue?vue&type=script&setup=true&lang=js"

import "./compGroupDetailProfiles.vue?vue&type=style&index=0&id=56795761&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56795761"]])

export default __exports__